import { useState, useEffect } from 'react';
import './HelloScreen.css';

// Импортируем изображения
import image1 from '../../Assets/Images/Slider/slide1.jpg';
import image2 from '../../Assets/Images/Slider/slide2.jpg';
import image3 from '../../Assets/Images/Slider/slide3.jpg';

const HelloScreen = () => {
  const slides = [
    { image: image1, title: "Сатурнский Хакатон", subtitle: "Первые в Олёкминском Районе!" },
    { image: image2, title: "Инновационные проекты", subtitle: "Решаем реальные задачи региона" },
    { image: image3, title: "Уникальный опыт", subtitle: "Попробуйте себя в роли предпринимаетля" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="hero-slider">
      {slides.map((slide, index) => (
        <div 
          key={index}
          className={`slide ${index === currentSlide ? 'active' : ''}`}
        >
          <img 
            src={slide.image} 
            alt="" 
            className="slide-image"
          />
          <div className="slide-overlay"></div>
          <div className="slide-content">
            <h1>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </div>
        </div>
      ))}
      
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Перейти к слайду ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HelloScreen;